import { render, staticRenderFns } from "./CompanyContractorsDBNew.vue?vue&type=template&id=9f5d7e66&scoped=true"
import script from "./CompanyContractorsDBNew.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorsDBNew.vue?vue&type=script&lang=ts"
import style0 from "./CompanyContractorsDBNew.vue?vue&type=style&index=0&id=9f5d7e66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d7e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5d7e66')) {
      api.createRecord('9f5d7e66', component.options)
    } else {
      api.reload('9f5d7e66', component.options)
    }
    module.hot.accept("./CompanyContractorsDBNew.vue?vue&type=template&id=9f5d7e66&scoped=true", function () {
      api.rerender('9f5d7e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/CompanyContractorsDBNew.vue"
export default component.exports